// Zuletzt geoeffnete Seiten (docs/shell.md).
//
// Wofuer: das Suchfeld oben soll bei LEERER Eingabe etwas Nuetzliches
// zeigen. In VS Code ist das die Liste der zuletzt geoeffneten Dateien,
// und der Grund ist derselbe wie hier -- man springt den ganzen Tag
// zwischen denselben fuenf Stellen hin und her.
//
// Bewusst nur Seiten und bewusst nur Pfade: das ist alles, was man
// braucht, um sie wieder zu oeffnen. Titel und Icon holt sich die
// Anzeige aus routes.ts, damit eine umbenannte Seite in der Liste nicht
// unter ihrem alten Namen weiterlebt.

import { untrack } from "svelte";

import { getPref, prefsGeladen, setPref } from "../prefs.svelte";

const PREF_KEY = "shell_recent";
const MAX = 12;

let liste = $state<string[]>([]);
let hergestellt = false;

export function stelleVerlaufHer(): void {
  if (hergestellt) return;
  const gemerkt = getPref<string[]>(PREF_KEY);
  if (Array.isArray(gemerkt)) {
    hergestellt = true;
    liste = gemerkt.slice(0, MAX);
    return;
  }
  // Nichts gefunden -- das heisst nur dann "es gibt nichts", wenn der
  // Server-Stand schon da ist. Sonst fragt die Shell spaeter nochmal
  // (21.08., derselbe Fall wie beim Tab-Stapel).
  if (prefsGeladen()) hergestellt = true;
}

/** merkeSeite schiebt einen Pfad nach vorn. Die Startseite bleibt
 *  draussen: sie hat ihr eigenes Symbol in der Aktivitaetsleiste und
 *  wuerde die Liste sonst dauerhaft anfuehren.
 *
 *  untrack ist hier PFLICHT, nicht Vorsicht: die Funktion wird aus
 *  einem $effect gerufen (Shell.svelte, "der Fokus hat gewechselt") und
 *  liest UND schreibt dieselbe Liste. Ohne untrack wird der Effekt von
 *  seinem eigenen Schreiben geweckt -- und weil hier jedes Mal ein
 *  neues Array entsteht, endet das nie: Svelte bricht mit
 *  effect_update_depth_exceeded ab und die halbe Oberflaeche steht
 *  still (gemessen am 14.08.). Der Schutz gehoert hierher, damit ihn
 *  nicht jeder Aufrufer neu bauen muss. */
export function merkeSeite(pfad: string): void {
  if (!pfad || pfad === "/") return;
  untrack(() => {
    if (liste[0] === pfad) return; // schon vorn: nichts zu tun
    const ohne = liste.filter((p) => p !== pfad);
    ohne.unshift(pfad);
    liste = ohne.slice(0, MAX);
    // Erst ab dem Server-Stand schreiben: sonst ueberschreibt der
    // allererste Fokus-Effekt den gemerkten Verlauf mit einem Eintrag.
    hergestellt = true;
    if (prefsGeladen()) setPref(PREF_KEY, liste);
  });
}

/** zuletztOhne liefert den Verlauf ohne die Pfade, die gerade schon
 *  offen sind -- ein Sprung zu etwas, das man vor sich hat, ist kein
 *  Angebot. */
export function zuletzt(ausschluss: Set<string> = new Set()): string[] {
  return liste.filter((p) => !ausschluss.has(p));
}
